import React, { useEffect, useMemo, useState } from 'react'
import ModalComponent from './Modal'
import AddressSearch from './AddressSearch'

const previewBoxStyle = {
    border: '1px solid #dcdcdc',
    borderRadius: '8px',
    padding: '12px',
    background: '#fafafa',
    marginTop: '12px',
}

const AddressLookupModal = ({
    showModal,
    setShowModal,
    title,
    initialAddress = '',
    onApply,
}) => {
    const [searchTerm, setSearchTerm] = useState(initialAddress || '')
    const [addressManualFill, setAddressManualFill] = useState(false)
    const [streetNumber, setStreetNumber] = useState('')
    const [streetName, setStreetName] = useState('')
    const [suburb, setSuburb] = useState('')
    const [state, setState] = useState('')
    const [postcode, setPostcode] = useState('')

    useEffect(() => {
        if (!showModal) {
            return
        }

        setSearchTerm(initialAddress || '')
        setAddressManualFill(false)
        setStreetNumber('')
        setStreetName('')
        setSuburb('')
        setState('')
        setPostcode('')
    }, [initialAddress, showModal])

    const isReadyToApply = useMemo(() => (
        !!searchTerm && !!streetName && !!suburb && !!(state?.value || state?.label || state) && !!postcode
    ), [postcode, searchTerm, state, streetName, suburb])

    const handleApply = () => {
        if (!isReadyToApply) {
            return
        }

        onApply && onApply({
            address: searchTerm,
            streetNumber,
            streetName: String(streetName || '').trim(),
            suburb: String(suburb || '').trim(),
            state: state?.value || state?.label || state,
            postcode: String(postcode || '').trim(),
        })
        setShowModal(false)
    }

    return (
        <ModalComponent showModal={showModal} setShowModal={setShowModal} contentStyle={{ maxWidth: '620px' }}>
            <h2 style={{ marginTop: 0 }}>{title}</h2>
            <AddressSearch
                errors={[]}
                errorMessage=''
                value={searchTerm}
                setValue={setSearchTerm}
                setLockAddressManualFields={() => { }}
                setAddressManualFill={setAddressManualFill}
                addressManualFill={addressManualFill}
                setStreetNumber={setStreetNumber}
                setStreetName={setStreetName}
                setSuburb={setSuburb}
                setState={setState}
                setPostcode={setPostcode}
            />
            <div style={previewBoxStyle}>
                <div><b>Selected address:</b> {searchTerm || '-'}</div>
                <div style={{ marginTop: '8px' }}><b>Unit / Street no:</b> {streetNumber || '-'}</div>
                <div style={{ marginTop: '8px' }}><b>Street:</b> {streetName || '-'}</div>
                <div style={{ marginTop: '8px' }}><b>Suburb:</b> {suburb || '-'}</div>
                <div style={{ marginTop: '8px' }}><b>State:</b> {state?.value || state?.label || state || '-'}</div>
                <div style={{ marginTop: '8px' }}><b>Postcode:</b> {postcode || '-'}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px' }}>
                <button
                    style={{ color: '#FF7100', background: 'white', border: '1px solid #FF7100' }}
                    onClick={() => setShowModal(false)}
                >
                    Close
                </button>
                <button disabled={!isReadyToApply} onClick={handleApply}>
                    Apply Address
                </button>
            </div>
        </ModalComponent>
    )
}

export default AddressLookupModal
